export default __webpack_public_path__ + "static/media/Flech_banner.37170199.png";